import React from 'react';

import Section from '../_common/Section';
import SectionHeaderSkeleton from '../_common/SectionHeaderSkeleton';
import { SelectFieldSkeleton } from '../_common/SelectFieldSkeleton';

export const Skeleton = React.forwardRef<HTMLDivElement>((props, ref) => (
  <Section ref={ref}>
    <SectionHeaderSkeleton />
    <SelectFieldSkeleton />
  </Section>
));

export function OfficeSkeleton() {
  return (
    <div>
      <div className="border border-b-0 border-gray-300">
        <div className="flex flex-col justify-between px-5 py-5 bg-gray-100 cursor-pointer space-y-2 lg:flex-row lg:items-center lg:space-x-4 lg:space-y-0">
          <div className="flex flex-1 lg:items-center">
            <div className="flex flex-1 flex-col justify-center space-y-1">
              <div className="w-64 h-5 bg-gray-300 rounded animate-pulse" />
              <div className="w-48 h-4 bg-gray-300 rounded animate-pulse" />
            </div>
            <div className="w-12 h-5 bg-gray-300 rounded animate-pulse" />
          </div>
        </div>
      </div>
      <div className="border border-gray-300">
        <div className="flex flex-col justify-between px-5 py-5 bg-gray-100 cursor-pointer space-y-2 lg:flex-row lg:items-center lg:space-x-4 lg:space-y-0">
          <div className="flex flex-1 lg:items-center">
            <div className="flex flex-1 flex-col justify-center space-y-1">
              <div className="w-64 h-5 bg-gray-300 rounded animate-pulse" />
              <div className="w-48 h-4 bg-gray-300 rounded animate-pulse" />
            </div>
            <div className="w-12 h-5 bg-gray-300 rounded animate-pulse" />
          </div>
        </div>
      </div>
    </div>
  );
}
